import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Button, Popconfirm, message } from "antd"
import { useDispatch } from "react-redux"
import { useEffect } from "react";

import { useDeleteQuizMutation } from "../../../features/quizzes/quizzesApi";
import { editQuiz, toggleModal } from "../../../features/quizzes/quizzesSlice";

export default function QuizRow({ quiz }) {
  const dispatch = useDispatch();
  const { id, question, video_id, video_title } = quiz || {}

  const [deleteQuiz, { isLoading, isError, error }] = useDeleteQuizMutation()
  const deleteHander = () => {
    deleteQuiz(quiz?.id)
  }

  useEffect(() => {
    if (isError) {
      const msg = typeof error?.data == 'string' ? error?.data : 'Internal server error'
      message.error(msg)
    }
  }, [error, isError])

  const editHandler = () => {
    dispatch(editQuiz(quiz))
    dispatch(toggleModal(true))
  }
  return (
    <tr>
      <td className="table-td max-w-sm truncate">{question}</td>
      <td className="table-td max-w-sm truncate">{video_title}</td>
      <td className="table-td ">
        <Popconfirm
          title="Delete the quiz"
          description="Are you sure to delete this quiz?"
          okText="Yes"
          cancelText="No"
          onConfirm={deleteHander}
        >
          <Button type="link" danger><DeleteOutlined /></Button>
        </Popconfirm>
        <Button type="link" onClick={editHandler}><EditOutlined /></Button>
      </td>
    </tr>
  )
}